export default __webpack_public_path__ + "static/media/logohome.64de44c9.svg";